import { FormControl, FormGroup } from '@angular/forms';
import { DateIntervalValidation } from '@validators/date-interval-validation';
import { DatePeriodValidation } from '@validators/date-period-validation';
import { DateValidation } from '@validators/date.validation';
import moment from 'moment';
var FilterComponent = /** @class */ (function () {
    function FilterComponent() {
        this.isFilterExpanded = false;
        this.defaultFilterValues = {
            openedAtGte: moment().subtract(1, 'month'),
            openedAtLte: moment(),
            closedAtGte: null,
            closedAtLte: null,
            scheduledAtGte: null,
            scheduledAtLte: null,
            locations: null,
            segments: null,
            companies: null,
            locationGroups: null,
            maintenanceTypes: null
        };
        this.filtersForm = new FormGroup({
            openedAtGte: new FormControl(this.defaultFilterValues.openedAtGte, [DateValidation.validate]),
            openedAtLte: new FormControl(this.defaultFilterValues.openedAtLte, [DateValidation.validate]),
            closedAtGte: new FormControl(this.defaultFilterValues.closedAtGte, [DateValidation.validate]),
            closedAtLte: new FormControl(this.defaultFilterValues.closedAtLte, [DateValidation.validate]),
            scheduledAtGte: new FormControl(this.defaultFilterValues.scheduledAtGte, [DateValidation.validate]),
            scheduledAtLte: new FormControl(this.defaultFilterValues.scheduledAtLte, [DateValidation.validate]),
            locations: new FormControl(this.defaultFilterValues.locations),
            maintenanceTypes: new FormControl(this.defaultFilterValues.maintenanceTypes),
            segments: new FormControl(this.defaultFilterValues.segments),
            companies: new FormControl(this.defaultFilterValues.companies),
            locationGroups: new FormControl(this.defaultFilterValues.locationGroups)
        }, {
            validators: [
                DateIntervalValidation.validate({
                    from: 'openedAtGte',
                    to: 'openedAtLte',
                    maxDiffLte: 1,
                    unit: 'year'
                }),
                DatePeriodValidation.validate(['openedAt', 'closedAt', 'scheduledAt'])
            ]
        });
    }
    return FilterComponent;
}());
export { FilterComponent };
